const ENV = process.env.VUE_APP_ENV

const _gateWay = {
  local: {
    mathCustomer: '/math-customer-app',
    ssoUrl: '/entry', // 把stage-mobile登录页面做本地代理，解决cookie无法种到带端口号的本地域名的问题
    parent: '/math-customer-parent',
    weixin: '/math-weixin',
    qrCode: '/activity-painter',
    unionaccount: '/pub/union-account',
    masterpage: 'http://stage-mobile.vipkid-qa.com.cn',
    domain: 'vipkid-qa.com.cn'
  },
  development: {
    mathCustomer: '/math-customer-app',
    ssoUrl: '//stage-mobile.vipkid-qa.com.cn/entry',
    parent: '/math-customer-parent',
    weixin: '/math-weixin',
    qrCode: '/activity-painter',
    unionaccount: '/pub/union-account',
    masterpage: 'http://stage-mobile.vipkid-qa.com.cn',
    domain: 'vipkid-qa.com.cn'
  },
  production: {
    mathCustomer: '//parent-app.vipkid.com.cn',
    ssoUrl: `//${location.host.match(/^pre-/) ? 'pre-' : ''}mobile.vipkid.com.cn/entry`,
    parent: `//${location.host.match(/^pre-/) ? 'pre-' : ''}edu.vipkid.com.cn/rest/gw/math-parent`,
    weixin: `//${location.host.match(/^pre-/) ? 'pre-' : ''}edu.vipkid.com.cn/rest/gw/math-weixin`,
    qrCode: `//${location.host.match(/^pre-/) ? 'pre-' : ''}edu.vipkid.com.cn/rest/gw/painter`,
    unionaccount: `//${location.host.match(/^pre-/) ? 'pre-' : ''}api.vipkid.com.cn/pub/union-account`,
    masterpage: `https://${location.host.match(/^pre-/) ? 'pre-' : ''}mobile.vipkid.com.cn`,
    domain: 'vipkid.com.cn'
  }
}

export default _gateWay[ENV] || _gateWay['production']
